
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/class-booking",
      function () {
        return require("private-next-pages/class-booking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/class-booking"])
      });
    }
  